import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export interface BankDetails {
  accountName: string;
  accountNumber?: string;
  address: string;
  bankName: string;
  iban: string;
  routingNumber?: string;
  swiftCode: string;
}

export interface CheckDetails {
  address: string;
  bankName: string;
}

export default class PaymentDetail extends Model {
  [Type] = 'payment-detail' as const;

  @attr('json') declare bankDetails: BankDetails | null;
  @attr('json') declare checkDetails: CheckDetails | null;
}
